import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * In production, redirects to home so "In Development" pages are inaccessible.
 * In development, renders children as normal.
 */
export const InDevelopmentRouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const isProduction = import.meta.env.PROD;

  useEffect(() => {
    if (isProduction) {
      navigate('/', { replace: true });
    }
  }, [isProduction, navigate]);

  if (isProduction) {
    return null;
  }
  return <>{children}</>;
};

export default InDevelopmentRouteGuard;
